import styled, {css} from "styled-components";
import { colors, devices, maxLinesStyle, sizes } from "../../../utils/styled";
import { shadowCardStyle } from "../Cards/shadowCard.style";
import { sectionStyle, titleStyle } from "../style";

const paginatorTextEffectStyle = css`
	color: ${colors.lemon};
	text-shadow: -1px 0 2px ${colors.bluegray}, 0 1px 2px ${colors.bluegray}, 1px 0 2px ${colors.bluegray}, 0 -1px 2px ${colors.bluegray};
`

export const RelatedContentContainer = styled.section`
	${shadowCardStyle}
	${sectionStyle}

	> .rel-content__section__title {
		padding-bottom: 24px;
		margin-bottom: 32px;
		${titleStyle}
	}

	> .rel-content__section__items__grid {
		flex: 1;
		column-gap: 32px;
		row-gap: 64px;
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		margin: 32px auto;

		@media ${devices.tablets} {
			flex-direction: column;
			grid-template-columns: 1fr 1fr;
			column-gap: 24px;
		}

		@media ${devices.mobile} {
			flex-direction: column;
			grid-template-columns: 1fr;
			row-gap: 56px;
		}
		transform: translateY(32px);
		opacity: 0;
		transition: transform 0.3s ease-out, opacity 0.5s ease-out;
		&.animate {
			transform: translateY(0);
			opacity: 1;
		}

		.rel-content__card--shadow {
			.rel-content__card--shadow__top {
				height: 170px;
			}
			.rel-content__card--shadow__body {
				height: 335px;
				.rel-content__card--shadow__body__title {
					h3 {
						${maxLinesStyle(2)}
						font-weight: 600;
					}
				}

				.rel-content__card--shadow__body__title {
					h3 {
						${maxLinesStyle(2)}
						font-weight: 600;
					}
				}
				@media ${devices.tablets} {
					height: 315px;
				}
				@media ${devices.desktop} {
					.rel-content__card--shadow__body__title {
						h3 {
							${maxLinesStyle(3)}
						}
					}
				}
			}
			@media ${devices.mobile} {
				.rel-content__card--shadow__top {
					height: 315px;
				}
				.rel-content__card--shadow__body {
					height: 215px;
					.rel-content__card--shadow__body__description {
						> p {
							${maxLinesStyle(4)}
						}
					}
				}
			}
		}
	}

	> .rel-content__section__paginator {
    display: flex;
    justify-content: flex-end;
		${(props) => (props.hidePaginator ? "display:none;" : "")}

		ul {
			display: flex;
			align-items: center;
			list-style: none;
			gap: 10px;

			@media (max-width: ${sizes.tabletSmall}px) {
				justify-content: flex-end;
			}

			li {
				a {
					cursor: pointer;
					color: ${colors.bluegray};
					&:hover {
						${paginatorTextEffectStyle}
					}
				}
				&.active {
					a {
						${paginatorTextEffectStyle}
						text-decoration: underline;
						text-underline-offset: 4px;
						text-decoration-thickness: 3px;
					}
				}
				&.disabled {
					display: none;
				}
			}
			li:first-of-type {
				margin-right: 10px;
			}
			li:last-of-type {
				margin-left: 10px;
			}
		}
	}
`;
